<template>
<v-row :class="['im-result', getClass(item.status) ]" align="center">
    <v-col md="1" v-if="$vuetify.breakpoint.mdAndUp" class="text-xs-center regular pa-0" @click="emitClick()">
        <span class="pl-2">
            {{item.id}}
        </span>
    </v-col>
    <v-col class="pa-0" v-if="$vuetify.breakpoint.mdAndUp" md="2" @click="emitClick()">
        <img :src="item.image" alt="" height="50" width="auto" style="border-radius: 10px;">
    </v-col>
    <v-col md="3" cols="8" class="pa-0" @click="emitClick()">
        <div class="important text-truncate px-1">
            {{ item.name }}
        </div>
        <div class="regular text-truncate px-1" v-if="$vuetify.breakpoint.smAndDown">
            {{ item.email }}
        </div>
    </v-col>
    <v-col md="3" cols="4" class="pa-0" @click="emitClick()">
        <div>
            <div class="regular text-truncate">
                {{ item.city }}
            </div>
            <div class="detail">
                {{ item.country.name }}
            </div>
        </div>
    </v-col>
    <v-col md="3" v-if="$vuetify.breakpoint.mdAndUp" class="pa-0">
        <span @click="emitClick()">
            {{ item.email }}
        </span>
        <v-icon class="delete-hotel-btn" v-if="delete_master" color="red" @click="delete_dialog=true">delete</v-icon>
    </v-col>

    <!--delete dialog-->
    <im-dialog-confirmation :dialog="delete_dialog" @cancel="delete_dialog=false" :loading="loading_delete" @delete="destroy()">
        <span slot="text-confirmation">Sunteti sigur ca doriti sa stergeti <span class="font-weight-bold">{{ item.name }}</span> din sistem? </span>
    </im-dialog-confirmation>
    <!--./delete dialog -->
    <v-snackbar v-model="error_image" color="error" bottom left>
        Nu poti sterge hotelul selectat
        <v-btn dark text @click="error_image = false">
            <v-icon>close</v-icon>
        </v-btn>
    </v-snackbar>
</v-row>
</template>

<script>
import {
    mapActions
} from 'vuex';
import ImDialogConfirmation from '../../../components/utils/ImDialogConfirmation.vue';
export default {
    name: `hotel-card`,

    props: {
        item: Object,
        delete_master: Boolean,
        hotel_id: [Number, String]
    },

    components: {
        "im-dialog-confirmation": ImDialogConfirmation
    },

    data() {
        return {
            delete_dialog: false,
            error_image: false,
            loading_delete: false
        }
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        getClass(value) {
            switch (value) {
            case 'suspended':
                return 'suspended';
            case 'published':
                return 'published';
            case 'accepted':
                return 'accepted';
            case 'registered':
                return 'registered';
            default:
                return '';
            }
        },

        destroy() {
            if(this.hotel_id == this.item.id) {
                this.error_image = true
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";

            // call delete endpoint
            this.$axios.delete(endpoint + this.item.id)
                .then(response => {
                    this.success('Hotelul a fost sters');
                    this.delete_dialog = false;
                    this.$emit('refresh');
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.loading_delete = false;
                });
        },

        emitClick() {
            this.$emit('click');
        },
    },
}
</script>
<style lang="stylus">
.delete-hotel-btn
    position: absolute
    right: 15px
.im-result
    &.published
        border-left: 5px solid #4CAF50
    &.accepted
        border-left: 5px solid #00c0ef
    &.registered
        border-left: 5px solid #4c4c4c
    &.suspended
        border-left: 5px solid #F44336
        background-color: #FFEBEE
</style>
